"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@emotion/react");

var _SocialNav = require("./SocialNav");

var _mapcDuotone = _interopRequireDefault(require("../assets/images/mapc-duotone.svg"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["margin-right: 30px;"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n        align-items: center;\n        color: ", ";\n        display: flex;\n        font-size: 16px;\n        flex-direction: row;\n        justify-content: space-between;\n        height: 90px;\n        padding: 0 ", "px 0 ", "px;\n        margin: 0 auto;\n        max-width: ", "px;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n        background-color: ", ";\n        width: 100%;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n    color: ", ";\n    text-decoration: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Footer = function Footer(_ref) {
  var backgroundColor = _ref.backgroundColor,
      _ref$fontColor = _ref.fontColor,
      fontColor = _ref$fontColor === void 0 ? '#FFFFFF' : _ref$fontColor,
      _ref$paddingLeft = _ref.paddingLeft,
      paddingLeft = _ref$paddingLeft === void 0 ? 50 : _ref$paddingLeft,
      _ref$paddingRight = _ref.paddingRight,
      paddingRight = _ref$paddingRight === void 0 ? 50 : _ref$paddingRight,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 1366 : _ref$maxWidth,
      props = (0, _objectWithoutProperties2.default)(_ref, ["backgroundColor", "fontColor", "paddingLeft", "paddingRight", "maxWidth"]);
  var linkStyles = (0, _react2.css)(_templateObject(), fontColor);
  return (0, _react2.jsx)("footer", Object.assign({
    css: (0, _react2.css)(_templateObject2(), backgroundColor)
  }, props), (0, _react2.jsx)("div", {
    css: (0, _react2.css)(_templateObject3(), fontColor, paddingRight, paddingLeft, maxWidth)
  }, (0, _react2.jsx)("div", {
    css: (0, _react2.css)(_templateObject4())
  }, (0, _react2.jsx)("a", {
    href: "https://www.mapc.org/",
    css: (0, _react2.css)(_templateObject5())
  }, (0, _react2.jsx)("img", {
    src: _mapcDuotone.default,
    alt: "MAPC logo"
  })), (0, _react2.jsx)("span", null, (0, _react2.jsx)("a", {
    href: "https://www.mapc.org/",
    css: linkStyles
  }, "Metropolitan Area Planning Council"), ' ', "|", ' ', (0, _react2.jsx)("a", {
    href: "tel:617-933-0700",
    css: linkStyles
  }, "617-933-0700"), ' ', "|", ' ', (0, _react2.jsx)("a", {
    href: "https://metrocommon.mapc.org/",
    css: linkStyles
  }, "metrocommon.mapc.org"))), (0, _react2.jsx)(_SocialNav.SocialNav, {
    color: fontColor
  })));
};

exports.Footer = Footer;